import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAppStateStore } from "@/store/app-state";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitButton',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const state = useAppStateStore();

const isInCompareMode = computed(() => {
	return router.currentRoute.value.name == "compare";
});

function toggleSplitView() {
	console.log("Split button clicked");
	if (isInCompareMode.value) {
		router.push({ name: "view", params: route.params });
	} else {
		router.push({ name: "compare", params: route.params });
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["split-button", { hidden: !_unref(state).canCompareProject, active: _unref(isInCompareMode) }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSplitView()))
  }, null, 2))
}
}

})